import { Component, inject } from '@angular/core';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { I18nService } from 'shared/module/i18n/i18n.service';
import { I18nModule } from 'shared/module/i18n/i18n.module';
import { Language } from 'shared/module/i18n/interface/language';
import { DeviceService } from '../../../service/device.service';

@Component({
  selector: 'app-lang-picker',
  standalone: true,
  imports: [
    NgOptimizedImage,
    I18nModule,
    NgClass
  ],
  templateUrl: './lang-picker.component.html',
  styleUrl: './lang-picker.component.scss'
})
export class LangPickerComponent {

  public i18nSvc = inject(I18nService);
  public deviceSvc = inject(DeviceService);

  expanded = false;

  langNames: Record<string, string> = {
    'cs-CZ': 'Čeština',
    'sk-SK': 'Slovenčina',
    'en-US': 'English'
  };

  /**
   * Updates the current language for the application. If the selected language
   * is the same as the current language, it collapses the selection without
   * performing any additional action. If a new language is selected, it updates
   * the language setting and reloads the application.
   *
   * @param {Language} lang - The language object representing the new language to be selected.
   * @return {void}
   */
  selectLanguage(lang: Language): void {
    if (this.i18nSvc.selLang === lang) {
      this.expanded = false;
      return;
    }
    this.i18nSvc.selLang = lang;
    location.reload();
  }
}
